import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import type { InputComponentProps, ValueComponentProps } from '../../../design-system';
import type { AddressFields } from '../../Address';
import { Address } from '../../Address';
import { SearchWrapper } from '../../SearchWrapper';
import { AddressDialogInput } from './AddressDialogInput';
import { AddressEditorSearchInput } from './AddressEditorSearchInput';

export type AddressInputProps = InputComponentProps<AddressFields> & {
  organisationId: string | undefined;
};

export const AddressInput: React.VFC<AddressInputProps> = ({
  disabled,
  helperText,
  name,
  organisationId,
}: AddressInputProps) => (
  <SearchWrapper>
    <AddressEditorSearchInput disabled={disabled} organisationId={organisationId} />
    <Box mb={1} />
    <AddressDialogInput disabled={disabled} name={name} helperText={helperText} />
  </SearchWrapper>
);

export const AddressValue: React.FC<ValueComponentProps<AddressFields>> = ({ value }) => (
  <Typography component="div" style={{ fontSize: 'inherit' }}>
    <Address multiline address={value} />
  </Typography>
);
